<div class="container-fluid g-0 m-0">
    <div class="row g-0 m-0 d-flex pt-5 align-items-center">
        <div class="col-md-1 d-flex pe-4 justify-content-end">
            <div class="button-back pb-3" [routerLink]="['/load-limit']">
                <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
            </div>
        </div>
        <div class="col-md-11">
            <h2 class="col pb-2 m-0 title">
                {{ "LOADLIMITSETUP" | translate }}
            </h2>
            <p class="col subtitle">{{ "LOADLIMITSUBTITLE" | translate }}</p>
        </div>
    </div>
    <form [formGroup]="loadLimitForm">
        <!--Select Type-->
        <div class="form-item">
            <label class="form-label" for="target">
                {{ "LOADLIMIT_SELECTTARGET" | translate }}</label>
            <div class="custom-div">
                <div class="radio-div custom-radio-div">
                    <div class="element" *ngFor="let item of meterTargetTypeDictionary">
                        <span class="radiobox" [ngClass]="{ selected: loadLimitForm.get('target')?.value === item }"
                            (click)="selectRadioOption('target', item)">
                            {{ item }}
                            <input id="{{item}}" type="radio" name="target" [value]="item" formControlName="target" />
                            <label for="{{ item }}"></label>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!--Single Meter-->
        @if(loadLimitForm.get('target')?.value == MeterTargetType.SingleMeter){
        <!--Meter Number-->
        <div class="form-item">
            <label class="form-label" for="meterNumber">{{ "DEVICESETUP_METERNO" | translate }}</label>
            <div class="form-input">
                <input [placeholder]="'METERNO_PLACEHOLDER' | translate" id="meterNumber" formControlName="meterNumber"
                    type="text" />
                <div *ngIf="formErrorsExists('meterNumber')" class="validation-error">
                    {{ "DEVICESETUP_METERNO" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                </div>
                <div *ngIf="!loadLimitForm.get('meterNumber')?.value" class="validation-instruction">
                    {{ "DEVICESETUP_METERNODESC" | translate }}
                </div>
                <div *ngIf="loadLimitForm.get('meterNumber')?.errors?.['pattern']" class="validation-error">
                    {{ "METERNUMBER_ERROR" | translate }}
                </div>
            </div>
        </div>
        <!--Limit Type-->
        <div class="form-item">
            <label class="form-label" for="limitType">{{ "LOADLIMITMANAGEMENT_LIMITTYPE" | translate }}</label>
            <div class="form-input select-wrapper">
                <select id="limitType" formControlName="limitType" class="with-placeholder"
                    placeholder="Select limit type" required>
                    <option *ngFor="let item of limitTypeDictionary" [value]="item.value">
                        {{ item.label }}
                    </option>
                </select>
                <span class="placeholder" *ngIf="!loadLimitForm.get('limitType')?.value"> {{ 'LIMITYPE_PLACEHOLDER' |
                    translate }} </span>
                <div *ngIf="formErrorsExists('limitType')" class="validation-error">
                    {{ "LOADLIMITMANAGEMENT_LIMITTYPE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                </div>
                <div *ngIf="!loadLimitForm.get('limitType')?.value" class="validation-instruction">
                    {{ "LOADLIMIT_LIMITTYPEDESC" | translate }}.
                </div>
            </div>
        </div>
        @if(loadLimitForm.get('limitType')?.value){
        <!--Threshold Value-->
        <div class="form-item">
            <label class="form-label" for="value">{{ "LOADLIMIT_THRESHOLDVALUE" | translate }}</label>
            <div class="form-input">
                <div class="value-container">
                    <span class="ps-2 pe-2 value-title">{{ "VALUE" | translate }}</span>
                    <input id="value" formControlName="value" type="text" />
                    <div class="value" [ngSwitch]="loadLimitForm.get('limitType')?.value">
                        <span *ngSwitchCase="LimitType.Current" class="p-1">Amps</span>
                        <span *ngSwitchCase="LimitType.Demand" class="p-1">kW</span>
                    </div>
                </div>
                <div *ngIf="formErrorsExists('value')" class="validation-error">
                    {{ "LOADLIMIT_THRESHOLDVALUE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                </div>
                <div *ngIf="!loadLimitForm.get('value')?.value" class="validation-instruction">
                    {{ "LOADLIMIT_THRESHOLDVALUEDESC" | translate }}
                </div>
                <div *ngIf="loadLimitForm.get('value')?.errors?.['pattern']" class="validation-error">
                    {{ "LOADLIMIT_THRESHOLDVALUERR" | translate }}
                </div>
            </div>
        </div>
        <!--Wait Time-->
        <div class="form-item">
            <label class="form-label" for="waitTime">{{ "LOADLIMIT_THRESHOLDWAITTIME" | translate }}</label>
            <div class="form-input">
                <div class="value-container">
                    <span class="ps-2 pe-2 value-title">{{ "VALUE" | translate }}</span>
                    <input id="value" formControlName="waitTime" type="text" />
                    <div class="value">
                        <span class="p-1">Sec</span>
                    </div>
                </div>
                <div *ngIf="!loadLimitForm.get('waitTime')?.value" class="validation-instruction">
                    {{ "LOADLIMIT_WAITTIMEDESC" | translate }}
                </div>
                <div *ngIf="loadLimitForm.get('waitTime')?.errors?.['pattern']" class="validation-error">
                    {{ "LOADLIMIT_WAITITMEERR" | translate }}
                </div>
            </div>
        </div>
        }
        }@else{
        <!--Group of Meters-->
        <div class="form-item">
            <label class="form-label" for="groupOfMeters">{{"GROUPOFMETERS" | translate}}</label>
            <div class="form-input select-wrapper">
                <select id="regions" (change)="onRegionSelected($event)" [value]="null" formControlName="regions">
                    <option *ngFor="let item of regions" [value]="item.value">
                        {{ item.name }}
                    </option>
                </select>
                <span class="placeholder" *ngIf="!loadLimitForm.get('regions')?.value"> {{ 'LOADLIMIT_REGIONS' |
                    translate }} </span>
                <div class="row m-0">
                    <div class="col-md-12 d-flex align-items-center justify-content-end clear"
                        *ngIf="selectedRegions.length > 0" (click)="clearRegions()">
                        <span>{{ "CLEAR" | translate }}</span>
                    </div>
                </div>
                <div class="row-md-12 selected-container custom-margins d-flex flex-wrap gap-3">
                    <div *ngFor="let region of selectedRegions"
                        class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center">
                        <span class="pe-2">{{ region.name }}</span>
                        <img (click)="removeRegion(region)" alt="Remove Region" src="assets/core/filter/filter-x.svg" />
                    </div>
                </div>
            </div>
        </div>
        @if(selectedRegions.length > 0){
        <div class="form-item d-flex justify-content-end">
            <div class="form-input">
                <div class="row pb-4">
                    <div class="col-md-6 select-wrapper">
                        <select id="assetType" formControlName="assetType">
                            <option *ngFor="let item of assetTypes" [value]="item.value">
                                {{ item.name }}
                            </option>
                        </select>
                        <div *ngIf="formErrorsExists('assetType')" class="validation-error">
                            {{ "LOADLIMITMANAGEMENT_LIMITTYPE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate
                            }}.
                        </div>
                        <span class="placeholder ps-2" *ngIf="!loadLimitForm.get('assetType')?.value"> {{
                            'ASSETYPE_PLACEHOLDER' |
                            translate }} </span>
                    </div>
                    <div class="col-md-6 select-wrapper">
                        <select id="serviceType" formControlName="serviceType">
                            <option *ngFor="let item of serviceTypes" [value]="item.value">
                                {{ item.name }}
                            </option>
                        </select>
                        <span class="placeholder ps-2" *ngIf="!loadLimitForm.get('serviceType')?.value"> {{
                            'SERVICETYPE_PLACEHOLDER' |
                            translate }} </span>
                        <div class="row m-0">
                            <div class="col-md-12 d-flex align-items-center justify-content-end clear"
                                *ngIf="loadLimitForm.get('serviceType')?.value" (click)="clearServiceType()">
                                <span>{{ "CLEAR" | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 select-wrapper">
                        <select id="meterPhase" formControlName="meterPhase">
                            <option *ngFor="let item of meterPhaseDictionary" [value]="item.value">
                                {{ item.label }}
                            </option>
                        </select>
                        <div *ngIf="formErrorsExists('meterPhase')" class="validation-error">
                            {{ "DEVICESETUP_METERPHASE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate
                            }}.
                        </div>
                        <span class="placeholder ps-2" *ngIf="!loadLimitForm.get('meterPhase')?.value"> {{
                            'METHERPHASE_PLACEHOLDER' |
                            translate }} </span>
                        <div class="row m-0">
                            <div class="col-md-12 d-flex align-items-center justify-content-end clear"
                                *ngIf="loadLimitForm.get('meterPhase')?.value" (click)="clearMeterPhase()">
                                <span>{{ "CLEAR" | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        @if(loadLimitForm.get('regions')?.value && loadLimitForm.get('assetType')?.value){
        <!--Limit Type-->
        <div class="form-item">
            <label class="form-label" for="limitType">{{ "LOADLIMITMANAGEMENT_LIMITTYPE" | translate }}</label>
            <div class="form-input select-wrapper">
                <select id="limitType" formControlName="limitType">
                    <option *ngFor="let item of limitTypeDictionary" [value]="item.value">
                        {{ item.label }}
                    </option>
                </select>
                <span class="placeholder" *ngIf="!loadLimitForm.get('limitType')?.value"> {{ 'LIMITYPE_PLACEHOLDER' |
                    translate }} </span>
                <div *ngIf="formErrorsExists('limitType')" class="validation-error">
                    {{ "LOADLIMITMANAGEMENT_LIMITTYPE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                </div>
                <div *ngIf="!loadLimitForm.get('limitType')?.value" class="validation-instruction">
                    {{ "LOADLIMIT_LIMITTYPEDESC" | translate }}.
                </div>
            </div>
        </div>
        }
        }
        @if(loadLimitForm.get('limitType')?.value){
        <!--Threshold Value-->
        <div class="form-item">
            <label class="form-label" for="value">{{ "LOADLIMIT_THRESHOLDVALUE" | translate }}</label>
            <div class="form-input">
                <div class="value-container">
                    <span class="ps-2 pe-2 value-title">{{ "VALUE" | translate }}</span>
                    <input id="value" formControlName="value" type="text" />
                    <div class="value" [ngSwitch]="loadLimitForm.get('limitType')?.value">
                        <span *ngSwitchCase="LimitType.Current" class="p-1">Amps</span>
                        <span *ngSwitchCase="LimitType.Demand" class="p-1">kW</span>
                    </div>
                </div>
                <div *ngIf="formErrorsExists('value')" class="validation-error">
                    {{ "LOADLIMIT_THRESHOLDVALUE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                </div>
                <div *ngIf="!loadLimitForm.get('value')?.value" class="validation-instruction">
                    {{ "LOADLIMIT_THRESHOLDVALUEDESC" | translate }}
                </div>
                <div *ngIf="loadLimitForm.get('value')?.errors?.['pattern']" class="validation-error">
                    {{ "LOADLIMIT_THRESHOLDVALUERR" | translate }}
                </div>
            </div>
        </div>

        <!--Wait Time-->
        <div class="form-item">
            <label class="form-label" for="waitTime">{{ "LOADLIMIT_THRESHOLDWAITTIME" | translate }}</label>
            <div class="form-input">
                <div class="value-container">
                    <span class="ps-2 pe-2 value-title">{{ "VALUE" | translate }}</span>
                    <input id="value" formControlName="waitTime" type="text" />
                    <div class="value">
                        <span class="p-1">Sec</span>
                    </div>
                </div>
                <div *ngIf="!loadLimitForm.get('waitTime')?.value" class="validation-instruction">
                    {{ "LOADLIMIT_WAITTIMEDESC" | translate }}
                </div>
                <div *ngIf="loadLimitForm.get('waitTime')?.errors?.['pattern']" class="validation-error">
                    {{ "LOADLIMIT_WAITITMEERR" | translate }}
                </div>
            </div>
        </div>
        }
        }
        <div class="form-item-button">
            <button class="button-submit" [disabled]="loadLimitForm.invalid || submitting ||
                      (loadLimitForm.get('target')?.value === MeterTargetType.SingleMeter && !loadLimitForm.get('meterNumber')?.value) ||
                      (loadLimitForm.get('target')?.value !== MeterTargetType.SingleMeter && selectedRegions.length === 0) ||
                      !loadLimitForm.get('waitTime')?.value" type="submit" (click)="onSubmit()">
                {{ "CREATE" | translate }}
            </button>
        </div>
    </form>
</div>